import IconUnknow from "~/components/Icons/mimeType/icon-unknow-file";
import IconPng from "~/components/Icons/mimeType/icon-png";
import IconJpeg from "~/components/Icons/mimeType/icon-jpeg";
import IconBmp from "~/components/Icons/mimeType/icon-bmp";
import IconCsv from "~/components/Icons/mimeType/icon-csv";
import IconWebp from "~/components/Icons/mimeType/icon-webp";
import IconWbmp from "~/components/Icons/mimeType/icon-wbmp";
import IconGif from "~/components/Icons/mimeType/icon-gif";
import IconPdf from "~/components/Icons/mimeType/icon-pdf";
import IconSvg from "~/components/Icons/mimeType/icon-svg";
import IconTiff from "~/components/Icons/mimeType/icon-tiff";
import IconDoc from "~/components/Icons/mimeType/icon-doc";
import IconXls from "~/components/Icons/mimeType/icon-xls";
import IconZip from "~/components/Icons/mimeType/icon-zip";
import IconGzip from "~/components/Icons/mimeType/icon-gzip";
import IconRar from "~/components/Icons/mimeType/icon-rar";
import IconPpt from "~/components/Icons/mimeType/icon-ppt";
import Icon7zip from "~/components/Icons/mimeType/icon-7zip";
import IconTxt from "~/components/Icons/mimeType/icon-txt";
import React from "react";

export const IconMimeType = (elem) => {
  const mimeType = elem.mimeType;
  const re = /(?:\.([^.]+))?$/;
  const point = re.exec(elem.link)[1];

  switch (mimeType) {
    case "image/png":
      return <IconPng />;
    case "image/jpeg":
      return <IconJpeg />;
    case "image/pjpeg":
      return <IconJpeg />;
    case "image/bmp":
      return <IconBmp />;
    case "image/x-windows-bmp":
      return <IconBmp />;
    case "image/csv":
      return <IconCsv />;
    case "image/webp":
      return <IconWebp />;
    case "image/vnd.wap.wbmp":
      return <IconWbmp />;
    case "image/gif":
      return <IconGif />;
    case "application/pdf":
      return <IconPdf />;
    case "image/svg+xml":
      return <IconSvg />;
    case "image/tiff":
      return <IconTiff />;
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return <IconDoc />;
    case "application/msword":
      return <IconDoc />;
    case "application/vnd.ms-excel":
      return <IconXls />;
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return <IconXls />;
    case "application/zip":
      return <IconZip />;
    case "application/x-zip-compressed":
      return <IconZip />;
    case "application/gzip":
      return <IconGzip />;
    case "application/x-rar-compressed":
      return <IconRar />;
    case "application/vnd.rar":
      return <IconRar />;
    case "application/x-rar":
      return <IconRar />;
    case "application/vnd.ms-powerpoint":
      return <IconPpt />;
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return <IconPpt />;
    case "application/x-7z-compressed":
      return <Icon7zip />;
    case "text/plain":
      return <IconTxt />;
    case "application/octet-stream":
      switch (point) {
        case "rar":
          return <IconRar />;
        case "wbmp":
          return <IconWbmp />;
        case "7z":
          return <Icon7zip />;
        default:
          return <IconUnknow />;
      }
    default:
      return <IconUnknow />;
  }
};
